import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
  Card
} from 'react-bootstrap';

import AuthContext from '../../Context/authContext';
import { userLogin } from '../../Services/api';
import { saveToStore } from '../../Utils/storage-helpers';
import Notification, { useNotification } from 'src/Components/Notification';

const JAMLYF_BLUE_DARK = "#41889A";

const LoginPage = () => {
  const [userEmail, setUserEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const { setAuth } = useContext(AuthContext);
  let navigate = useNavigate();
  const { notifyError, onClose, notification } = useNotification();

  const validateForm = () => userEmail.length > 0 && password.length > 0;
  const togglePassword = () => setPasswordShown(!passwordShown);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const email = userEmail.toLowerCase();
    const data = { email, password };
    const login_res = await userLogin(data);
    setIsLoading(false);
    if (login_res.status !== 200) {
      notifyError({ message: login_res.response.data.detail });
      setAuth(false);
    } else {
      await saveToStore('accessToken', login_res.data.access_token);
      await saveToStore('user', login_res.data.user);
      setAuth(true);
    }
  };

  return (
    <Container className='d-flex justify-content-center align-items-center vh-100'>
      <Notification id="login-error" onClose={onClose} {...notification} />
      <Row className="w-100">
        <Col xs={12} sm={10} md={10} lg={6} className="mx-auto">
          <Card className="border rounded p-4 shadow-sm">
            <Card.Body>
              <div className='text-center mb-4'>
                <h4 className='text-secondary text-capitalize'>Welcome back</h4>
                <p className='text-muted m-auto'>
                  Enter your credentials to access your account
                </p>
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId='formEmail' className='mb-3'>
                  <Form.Control
                    autoFocus
                    type='text'
                    placeholder='Email'
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    className="text-dark border rounded"
                  />
                </Form.Group>

                <Form.Group controlId='formPassword' className='mb-3'>
                  <InputGroup>
                    <Form.Control
                      placeholder='Password'
                      type={passwordShown ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="text-dark border rounded"
                    />
                    <InputGroup.Text>
                      <FontAwesomeIcon
                        icon={passwordShown ? faEye : faEyeSlash}
                        onClick={togglePassword}
                        style={{ cursor: "pointer" }}
                      />
                    </InputGroup.Text>
                  </InputGroup>
                  <div className="text-end mt-2">
                    <Button
                      variant="link"
                      className="text-primary fw-bold"
                      style={{ textDecoration: "none", color: JAMLYF_BLUE_DARK }}
                      onClick={() => navigate("/reset-password")}
                    >
                      Reset Password
                    </Button>
                  </div>
                </Form.Group>

                <div className='d-grid'>
                  <Button
                    type='submit'
                    disabled={!validateForm() || isLoading}
                    className='w-100'
                    style={{ backgroundColor: JAMLYF_BLUE_DARK, borderColor: JAMLYF_BLUE_DARK }}
                  >
                    {isLoading && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    )}
                    Sign in
                  </Button>
                </div>
              </Form>

              <p className='text-center text-secondary mt-3'>
                Don't have an account?
                <Button
                  variant='link'
                  className='px-1 text-primary fw-bold'
                  style={{ color: JAMLYF_BLUE_DARK }}
                  onClick={() => navigate('/signup')}
                >
                  Register
                </Button>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
